import React from 'react';

import Page from '@sayyesschool/frontend/components/page';
import { IconButton } from '@sayyesschool/frontend/ui-components';

import MeetingForm from '@/components/meetings/meeting-form';

import styles from './MeetingDetails.module.scss';

export default function MeetingDetails({ meeting, hosts, onUpdate }) {
    return (
        <Page.Section
            className={styles.root}
            title="Детали"
            actions={
                <IconButton
                    icon="save"
                    type="submit"
                    form="meeting-form"
                    title="Сохранить"
                />
            }
        >
            <MeetingForm
                id="meeting-form"
                meeting={meeting}
                hosts={hosts}
                onSubmit={onUpdate}
            />
        </Page.Section>
    );
}